import * as React from 'react';
import { IFormControlCommonProps } from './form-control-common-props';
import { MultiSelectItem } from '../../loggedinweb-generated';
import { MultiSelect, MultiSelectStore, IMultiSelectProps } from '../multi-select';
import { MultiSelect as MultiSelectOld, MultiSelectStore as MultiSelectStoreOld } from '../multi-select-old';
import { getElementId } from '../form-controls/form-control-utils';
import { ArrayHelper } from '../../helpers/arrayhelper';

export interface IFormControlMultiSelectProps extends IFormControlCommonProps {
	items: MultiSelectItem[];
	onChangeHandler: (selectedValues: string[]) => void;
	selectedValues?: string[];
	acceptanceTestTargetId?: string;
}

export class FormControlMultiSelect extends React.Component<IFormControlMultiSelectProps> {
	private multiSelectStore;

	constructor(props) {
		super(props);

		const { items, onChangeHandler, selectedValues } = props;

		this.multiSelectStore = NewFeatures.RecurringGivingEnhancements
			? new MultiSelectStore({ Items: items, SelectedValues: selectedValues }, null, onChangeHandler)
			: new MultiSelectStoreOld({ Items: items, SelectedValues: selectedValues }, null, onChangeHandler);
	}

	render() {
		const { uniqueSuffix, name, acceptanceTestTargetId } = this.props;

		const MultiSelectComponent: React.ComponentClass<any> = NewFeatures.RecurringGivingEnhancements ? MultiSelect : MultiSelectOld;
		const props: IMultiSelectProps = {
			multiSelectStore: this.multiSelectStore,
			fieldName: name,
			id: getElementId(name, uniqueSuffix),
			acceptanceTestTargetId: acceptanceTestTargetId
		};
		return <MultiSelectComponent {...props} />
	}

	UNSAFE_componentWillReceiveProps(nextProps: IFormControlMultiSelectProps) {
		const { selectedValues: currentValues } = this.props;
		const { selectedValues } = nextProps;

		if (currentValues && currentValues.length && selectedValues && !selectedValues.length) {
			this.multiSelectStore.reset();
		}

		if(!ArrayHelper.equals(currentValues, selectedValues)) {
			this.multiSelectStore.setSelectedItems(selectedValues);
		}
	}
}
